import React from 'react';
import ClasseNoteEleveCard from 'components/ClasseNoteEleveCard';
import ClassWorkspaceLayout from 'components/ClassWorkspaceLayout';

import { useDispatch, useSelector } from 'react-redux'

import axios from 'axios';
import { useHistory } from 'react-router-dom';

export default function Note(props) {
    const dispatch = useDispatch()
    const history = useHistory()
    const noteRoute = props.location && props.location.state
    const classes = useSelector(state => state.classeDetail.arr)
    const userConnected = useSelector(state => state.userConnected.user_connected)
    const evaluatedStudents = useSelector(state => state.eleveNbNoteDetail.eleve.nb_eleve_note)

    const currentClass = Array.isArray(classes)
        ? classes.find((classe) => String(classe.id_classe) === String(noteRoute && noteRoute.id_classe))
        : null

    const classLabel = noteRoute && noteRoute.classLabel
        ? noteRoute.classLabel
        : currentClass
            ? `${currentClass.nom_classe || ''} ${currentClass.nom_etablissement || ''}`.trim()
            : noteRoute
                ? `Classe ${noteRoute.id_classe}`
                : ''
    const classLevels = noteRoute && noteRoute.classLevels
        ? noteRoute.classLevels
        : currentClass && currentClass.niveau
    const classStudentCount = noteRoute && noteRoute.studentCount !== undefined
        ? noteRoute.studentCount
        : currentClass && currentClass.nbEleves !== undefined
            ? currentClass.nbEleves
            : evaluatedStudents

    React.useEffect(() => {
        if (!noteRoute || !noteRoute.id_classe || !noteRoute.id_seance) {
            history.replace('/compte')
            return
        }

        dispatch({ type: 'note/noteDetail', payload: [] });
        dispatch({ type: 'note/eleveNbNoteDetail', payload: 0 });

        axios.get('https://eps.acces-editions.com/api/getNoteEleveSceance?id_classe='+noteRoute.id_classe+'&id_seance='+noteRoute.id_seance)
        .then((res) => {
            if(res.data[0] !== undefined)
            {
                dispatch({ type: 'note/noteDetail', payload: res.data});
            } else {
                dispatch({ type: 'note/noteDetail', payload: [] });
            }
        })
        .catch(() => dispatch({ type: 'note/noteDetail', payload: [] }))

        axios.get('https://eps.acces-editions.com/api/getNoteClasseSeanceSpec?id_classe='+noteRoute.id_classe+'&id_seance='+noteRoute.id_seance)
        .then((res) => {
            if(res.data[0] !== undefined)
            {
                dispatch({ type: 'note/eleveNbNoteDetail', payload: res.data[0].nbNote});
            } else {
                dispatch({ type: 'note/eleveNbNoteDetail', payload: 0 });
            }
        })
        .catch(() => dispatch({ type: 'note/eleveNbNoteDetail', payload: 0 }))
        window.scrollTo(0, 0)

    }, [noteRoute, dispatch, history]);

    if (!noteRoute || !noteRoute.detailSeance) return null

    return (
        <ClassWorkspaceLayout
            title="Détail de l'évaluation"
            subtitle="Consultez et ajustez les résultats de chaque élève pour cette activité."
            classLabel={classLabel}
            studentCount={classStudentCount}
            levels={classLevels || ''}
            user={userConnected}
        >
            <ClasseNoteEleveCard
                positionEleve={noteRoute.positionEleve}
                activity={noteRoute.detailSeance.titre_activite}
                objective={noteRoute.detailSeance.objectif}
                evaluatedStudents={evaluatedStudents}
            />
        </ClassWorkspaceLayout>
    );
}
